export const updateNotificationBadges = (html) => {
  const template = document.createElement('template');

  // The response is trusted server-rendered HTML from our own sidebar endpoint.
  // eslint-disable-next-line no-unsanitized/property
  template.innerHTML = html;

  template.content.querySelectorAll('[data-notification-badge-key]').forEach((source) => {
    const key = source.dataset.notificationBadgeKey;
    const visible = source.dataset.notificationBadgeVisible === 'true';
    const count = source.querySelector('.number')?.textContent;

    document.querySelectorAll(`[data-notification-badge-key="${key}"]`).forEach((target) => {
      if (visible) {
        target.style.removeProperty('display');
      } else {
        target.style.display = 'none';
      }

      target.dataset.notificationBadgeVisible = String(visible);

      const number = target.querySelector('.number');

      if (number && count !== undefined) {
        number.textContent = count;
      }
    });
  });
};
